import { PaletteColorOptions } from '@mui/material/styles';
import { FORM_SURFACE_PRIMARY } from './embedTheme.constants';

export interface SurfacePalette {
  background: string;
  paper: string;
  divider: string;
  text: string;
  textSecondary: string;
}

const readCssVar = (name: string) =>
  getComputedStyle(document.documentElement).getPropertyValue(name).trim();

export const readPrimaryPalette = (): PaletteColorOptions => {
  const main = readCssVar('--primary-600');
  if (!main) return { main: FORM_SURFACE_PRIMARY };
  return {
    light: readCssVar('--primary-400') || undefined,
    main,
    dark: readCssVar('--primary-700') || undefined,
  };
};

export const readSurfacePalette = (): SurfacePalette | undefined => {
  const surfaces: SurfacePalette = {
    background: readCssVar('--admin-canvas'),
    paper: readCssVar('--admin-surface'),
    divider: readCssVar('--admin-border'),
    text: readCssVar('--admin-text'),
    textSecondary: readCssVar('--admin-text-muted'),
  };
  return Object.values(surfaces).every(Boolean) ? surfaces : undefined;
};
